export enum EInfoportalApiUrls {
  publications = '/api/ms-content-infoportal-backend/v1/admin/publications',
  rubrics = '/api/ms-content-infoportal-backend/v1/admin/rubrics',
  tags = '/api/ms-content-infoportal-backend/v1/admin/tags',
  tagsPriorities = '/api/ms-content-infoportal-backend/v1/admin/rubrics/priorities',
  mainPublications = '/api/ms-content-infoportal-backend/v1/admin/publications/main',
  uploadImage = '/api/v1/image_upload-for-publication',
  publicationsCount = '/api/ms-content-infoportal-backend/v1/admin/publications/count',
}
